// barcode.component.ts
import { Component, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'app-sale-barcode',
  template: `<svg #barcode></svg>`,
  styles: ['svg { width: 100%; height: auto; }']
})
export class BarcodeComponent implements AfterViewInit {

  @ViewChild('barcode', { static: false }) barcode?: ElementRef<SVGElement>;

  @Input() barcodeData?:string;

  ngAfterViewInit() {
    if (this.barcodeData!=null) {
      this.generateBarcode(this.barcodeData);
    }
  }

  generateBarcode(data: string) {
    if (this.barcode==null) {
      return;
    }

    JsBarcode(this.barcode.nativeElement, data, {
      format: 'CODE128',
      lineColor: '#000000',
      width: 2,
      height: 50,
      displayValue: false
    });

    const svgElement = this.barcode.nativeElement.querySelector('svg');
    if (svgElement) {
      svgElement.style.width = '100%';
      svgElement.style.height = 'auto';
    }
  }
}
